import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Youtube } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <img 
                src="/assets/logo.png" 
                alt="Prestige AI" 
                className="h-10 w-10 object-contain"
              />
              <span className="text-xl font-bold text-white">Prestige AI</span>
            </Link>
            <p className="text-gray-300 mb-4">
              Revolutionizing financial reporting and auditing with AI-powered solutions.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/profile.php?id=61573573650788" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-white"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a 
                href="https://twitter.com/4PrestigeAI" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-white"
              >
                <Twitter className="h-5 w-5" />
              </a>
              <a 
                href="https://www.youtube.com/@prestigeai-gdb" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-white"
              >
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white">Home</Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white">About Us</Link>
              </li>
              <li>
                <Link to="/solutions" className="text-gray-300 hover:text-white">Solutions & Pricing</Link>
              </li>
              <li>
                <Link to="/confidentiality" className="text-gray-300 hover:text-white">Confidentiality & Security</Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="#" onClick={(e) => {
                  e.preventDefault();
                  const event = new CustomEvent('open-terms-modal');
                  window.dispatchEvent(event);
                }} className="text-gray-300 hover:text-white">Terms of Use</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-2">
              <li className="flex items-center space-x-2">
                <Mail className="h-5 w-5 text-cyan-500" />
                <div className="flex flex-col">
                  <a href="mailto:support@prestigeai.tech" className="text-gray-300 hover:text-white">support@prestigeai.tech</a>
                  <a href="mailto:sales@prestigeai.tech" className="text-gray-300 hover:text-white">sales@prestigeai.tech</a>
                </div>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="h-5 w-5 text-cyan-500" />
                <span className="text-gray-300">+27 76 480 3656</span>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="h-5 w-5 text-cyan-500 flex-shrink-0 mt-1" />
                <span className="text-gray-300">Pretoria, South Africa</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Prestige AI. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;